// useHistogramData.ts
import { useMemo, useState, useEffect } from "react";
import { getConversationalSuccessHistogram } from "../api/controllers/conversationalSuccessHistogram";

type Args = {
    applicationId: string;
    startDate: string; // ISO "YYYY-MM-DD"
    endDate: string;   // ISO "YYYY-MM-DD"
    categories: string[];
    tags: string[];
    interval: number
};

export function useHistogramData({ applicationId, startDate, endDate, categories, tags, interval }: Args) {
    const [data, setData] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const result = await getConversationalSuccessHistogram(
                    applicationId,
                    startDate,
                    endDate,
                    interval,
                    categories,
                    tags
                );
                setData(result.data);
            } catch (err) {
                setError(err instanceof Error ? err : new Error('An error occurred'));
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [applicationId, startDate, endDate, categories, tags]);

    return { data, loading, error }
}